import type { ProductCategory, CategoryConfig } from '@/types';
import { PRINT_RATIOS } from '@/types';

/**
 * Product Category Configurations
 * 
 * Each category defines:
 * - Available print ratios
 * - Mockup requirements
 * - README PDF association
 * - Processing pipeline
 */

export const CATEGORY_CONFIGS: Record<ProductCategory, CategoryConfig> = {
  'digital-art-print': {
    id: 'digital-art-print',
    label: 'Digital Art - Print',
    description: 'Standard digital art prints with all 5 print ratios',
    printRatios: PRINT_RATIOS, // All 5 standard ratios
    requiresMockups: true,
  },
  'tv-art-16-9': {
    id: 'tv-art-16-9',
    label: 'TV Art (16:9)',
    description: 'Digital art optimized for TV displays',
    printRatios: [], // Will be defined when implemented
    requiresMockups: false,
  },
  'triptych': {
    id: 'triptych',
    label: 'Triptych (3-Panel)',
    description: 'Multi-panel artwork split into 3 pieces',
    printRatios: [], // Will be defined when implemented
    requiresMockups: true,
  },
  'diptych': {
    id: 'diptych',
    label: 'Diptych (2-Panel)',
    description: 'Multi-panel artwork split into 2 pieces',
    printRatios: [], // Will be defined when implemented
    requiresMockups: true,
  },
};

/**
 * Get available categories for product creation
 * Currently only Digital Art - Print is implemented
 */
export const AVAILABLE_CATEGORIES: ProductCategory[] = [
  'digital-art-print',
  // Future categories will be added here as they're implemented
];

/**
 * Get category configuration by ID
 */
export function getCategoryConfig(category: ProductCategory): CategoryConfig {
  return CATEGORY_CONFIGS[category];
}

/**
 * Check if a category is available for use
 */
export function isCategoryAvailable(category: ProductCategory): boolean {
  return AVAILABLE_CATEGORIES.includes(category);
}

